enum FormTemplateCategoryFieldNames {
  Id = 'id',
  Color = 'color',
  Name = 'name',
}

export default FormTemplateCategoryFieldNames;
